export const types = {
  BOTH: 'both',
  SMS: 'sms',
  EMAIL: 'email',
}
